var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7812 10C13.875 10 13.4688 10.5 12 10.5C10.5 10.5 10.0938 10 9.1875 10C6.875 10 5 11.9062 5 14.2188V15.5C5 16.3438 5.65625 17 6.5 17H17.5C18.3125 17 19 16.3438 19 15.5V14.2188C19 11.9062 17.0938 10 14.7812 10ZM18 15.5C18 15.7812 17.75 16 17.5 16H6.5C6.21875 16 6 15.7812 6 15.5V14.2188C6 12.4375 7.40625 11 9.1875 11C9.8125 11 10.4062 11.5 12 11.5C13.5625 11.5 14.1875 11 14.7812 11C16.5625 11 18 12.4375 18 14.2188V15.5ZM12 9C14.1875 9 16 7.21875 16 5C16 2.8125 14.1875 1 12 1C9.78125 1 8 2.8125 8 5C8 7.21875 9.78125 9 12 9ZM12 2C13.625 2 15 3.375 15 5C15 6.65625 13.625 8 12 8C10.3438 8 9 6.65625 9 5C9 3.375 10.3438 2 12 2Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0757c3b4.svg";
export { ForwardRef as ReactComponent };